<ng-container *ngIf="displayModel1">
  <p-dialog
    header="Report"
    [(visible)]="displayModel1"
    [modal]="true"
    [contentStyle]="{ overflow: 'scroll' }"
    [style]="{ width: '100vw' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
    (onHide)="CloseDialog()"
  >
    <div
      *ngIf="
        this.doctorReportsSuccess != null && this.doctorReportsSuccess == true
      "
    >
      <div class="spaces"></div>

      <app-doctorreportpdf
        [data]="this.doctorReportsData"
        [dataId]="showDoctorReports"
      ></app-doctorreportpdf>

      <p-button
        icon="pi pi-check"
        (click)="print()"
        label="Print"
        styleClass="p-button-text"
      ></p-button>
    </div>
  </p-dialog>

  <div
    *ngIf="
      this.doctorReportsSuccess != null && this.doctorReportsSuccess == true
    "
  >
    <div class="spaces"></div>

    <app-doctorreportpdf
      [data]="this.doctorReportsData"
      [dataId]="printContent"
    ></app-doctorreportpdf>
  </div>
</ng-container>

<div class="card no-margin">
  <div>
    <label style="margin: 2px; margin-right: 80px; vertical-align: super"
      ><b>Choose a Patient : </b></label
    >
    <!-- <p-dropdown id="dropdown" [(ngModel)]="member_value" optionLabel="name" [options]="members" (ngModelChange)="onMemberChange($event)"></p-dropdown> -->
    <!-- <p-dropdown [(ngModel)]="member_value" optionLabel="name" [options]="members"></p-dropdown> -->
    <p-dropdown
      id="patient" class="notranslate"
      [options]="members_list"
      placeholder="Select"
      optionLabel="label"
      [(ngModel)]="selectedMember"
      (ngModelChange)="onMemberChange($event.value)"
      [disabled]="posting"
    >
    </p-dropdown>
  </div>
</div>
<div *ngIf="member_value && posting == false">
  <div class="card no-margin">
    <div
      class="table-responsive text-center justify-content-center"
      style="
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
        vertical-align: center;
      "
    >
      <p-table
        #dt1
        [value]="request"
        dataKey="id"
        styleClass="p-datatable-customers"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="[
          'consultation_request_number',
          'date',
          'consultation_type',

          'speciality_name',
          'Doctor',
          'consultation_status',
          'Appointment_date',

          'consultations_left'
        ]"
      >
        <ng-template pTemplate="caption">
          <div class="table-header float-right">
            <span class="p-input-icon-left">
              <input
                pInputText
                type="text"
                (input)="dt1.filterGlobal($event.target.value, 'contains')"
                placeholder="Search"
              />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="consultation_request_number">
              <b>Request No</b>
              <p-sortIcon field="consultation_request_number"></p-sortIcon>
            </th>
            <th pSortableColumn="date">
              <b>Date</b>
              <p-sortIcon field="date"></p-sortIcon>
            </th>
            <th pSortableColumn="consultation_type">
              <b>Consultation Type</b>
              <p-sortIcon field="consultation_type"></p-sortIcon>
            </th>
            <!-- <th pSortableColumn="priority_type"><b>Priority</b>
                            <p-sortIcon field="priority_type"></p-sortIcon>
                        </th> -->
            <th pSortableColumn="speciality_name">
              <b>Specialty</b>
              <p-sortIcon field="speciality_name"></p-sortIcon>
            </th>
            <th pSortableColumn="Doctor">
              <b>Doctor/OHP </b>
              <p-sortIcon field="Doctor"></p-sortIcon>
            </th>
            <th pSortableColumn="consultation_status">
              <b>Consultation Status</b>
              <p-sortIcon field="consultation_status"></p-sortIcon>
            </th>
            <th pSortableColumn="Appointment_date">
              <b>Appt. Date </b>
              <p-sortIcon field="Appointment_date"></p-sortIcon>
            </th>
            <th pSortableColumn="communication_name">
              <b>Communication</b>
              <p-sortIcon field="communication_name"></p-sortIcon>
            </th>

            <th pSortableColumn="consultations_left">
              <b>Consultations Left</b>
              <p-sortIcon field="consultations_left"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-request>
          <tr [pSelectableRow]="request">
            <td class="notranslate">
              {{ request.consultation_request_number }}
            </td>
            <td class="notranslate">
              <span>{{ request.date | date: 'medium' }}</span>
            </td>
            <td>
              <span>{{ request.consultation_type }}</span>
            </td>
            <!-- <td>

                            <span>{{request.priority_type}}</span>
                        </td> -->
            <td class="notranslate">
              <span *ngFor="let sp of request.specialty_name">
                <p-message severity="success" text="{{ sp }}"></p-message>
              </span>
            </td>
            <td class="notranslate">
              <span *ngFor="let sp of request.Doctor">
                <p-message severity="success" text="{{ sp }}"></p-message>
              </span>
            </td>
            <td>
              <span>{{ request.consultation_status }}</span>
              <!-- <div *ngIf="request.consultation_status == 'CLOSED'">
                <span>
                  <p-button
                    (click)="gotoReportpdf(request.id)"
                    icon="pi pi-external-link"
                    label="Doctor Report"
                  ></p-button>
                </span>
              </div> -->
            </td>
            <td class="notranslate">
              <span>{{
                request.Appointment_date == null
                  ? 'TBD'
                  : (request.Appointment_date | date: 'medium')
              }}</span>
            </td>
            <td>
              {{
                request.consultation_status == 'CLOSED'
                  ? request.communication_name
                  : ''
              }}

              <div class="card" *ngIf="request.consultation_status != 'CLOSED'">
                <div class="card" *ngIf="request.Zoom_meetings.length == 0">
                  <h4>Zoom Video</h4>
                </div>
                <div class="card" *ngIf="request.Zoom_meetings.length > 0">
                  <a
                    [href]="request.Zoom_meetings"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><button
                      pButton
                      type="button"
                      label=" Join Zoom"
                      class="ui-button-info ui-button-rounded"
                      style="float: inline-start; margin-top: 10px"
                    ></button
                  ></a>
                </div>
              </div>
            </td>

            <td>
              <span class="notranslate">{{ request.consultations_left }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10">No Data found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft"> </ng-template>
        <ng-template pTemplate="paginatorright"> </ng-template>
      </p-table>
    </div>
  </div>

  <div class="container-flex row">
    <h4>
      <b>All times are in your local time zone - {{ TZ }}</b>
    </h4>
  </div>
  <div class="container-flex row">
    <h4>
      <b>Note* </b>: If document status is
      <span style="color: red">Not Completed</span>, please attach all necessary
      documents in order for the doctor to review before you meet.
    </h4>
    <h4><b></b>Failure to do so may result in delay of the consultation.</h4>
  </div>
  <!-- <div class="wrapper">
            
            <button pButton type="button" label="Back" routerLink="/patient" style="margin-bottom:10px;margin-right:5px;" class="ui-button-info ui-button-rounded"></button>
        </div> -->
  <div style="text-align-last: right">
    <p-button
      type="button"
      [style]="{
        'margin-right': '5px',
        'margin-top': '3px',
        'background-color': 'white',
        color: '#004AAD',
        'border-radius': '5px'
      }"
      [routerLink]="['/', this.slug, 'patient']"
      label="Back"
      class="p-button-lg"
      icon="pi pi-arrow-left"
    ></p-button>
  </div>
</div>
<div
  class="row container justify-content-center text-center alert alert-danger"
  *ngIf="response.success != null && response.success == false"
>
  <p *ngIf="response.error != null">{{ response.error.message }}</p>
  <div *ngIf="serverError?.error != null && serverError?.statusCode != 500">
    <p *ngFor="let message of serverError?.message">{{ message }}</p>
  </div>
  <div *ngIf="serverError?.error != null && serverError?.statusCode == 500">
    <p>{{ serverError?.message }}</p>
  </div>
</div>
<h4 *ngIf="posting">Fetching Data...</h4>
<p-progressSpinner
  [style]="{ width: '50px', height: '50px' }"
  *ngIf="posting"
  strokeWidth="6"
></p-progressSpinner>
